import { z } from "zod";
export const ControlledAiClarificationResultV1Schema = z.object({
    schemaVersion: z.literal("controlled-ai-clarification.v1.0"),
    requirementId: z.literal("AI-004"),
    ok: z.boolean(),
    humanContinuationRequired: z.boolean(),
    detail: z.string().optional(),
}).strict();
export function buildClarificationQuestions(input) {
    const malformed = input.payload.trim().length === 0;
    return ControlledAiClarificationResultV1Schema.parse({
        schemaVersion: "controlled-ai-clarification.v1.0",
        requirementId: "AI-004",
        ok: !malformed,
        humanContinuationRequired: true,
        detail: malformed ? "malformed_or_low_confidence" : undefined,
    });
}
//# sourceMappingURL=clarification.js.map